import React, { useEffect, useRef, useState } from "react";
import { Alert, Container, Snackbar } from "@mui/material";
import {
  ConnectUserRequest,
  ConnectUserResponse,
  Role,
} from "api/models/heartintune-profile-service/heartintune-profile_pb";
import { grpc } from "@improbable-eng/grpc-web";
import { HeartIntuneProfileService } from "api/models/heartintune-profile-service/heartintune-profile_pb_service";
import { HEARTINTUNE_PROFILE_SERVICE_HOST } from "api/serviceEndpoints";
import { UnaryOutput } from "@improbable-eng/grpc-web/dist/typings/unary";
import { useDispatch } from "react-redux";
import { userRoleUpdate } from "redux/reducers/userReducer";
import { useHistory } from "react-router";
import { userLogout } from "hfn-auth-legacy/dist/main";
import CircularProgress from '@mui/material/CircularProgress';
import Box from "@mui/material/Box";
import { forceLogout, getKeycloakAuthConfig } from "config/keycloak";

interface State {
  loading?: boolean;
  showError?: boolean;
  errorMessage?: string;
  formErrors?: {
    email: boolean;
    password: boolean;
  };
}

export default function LoginScreen() {
  const apiCallCount = useRef(0);
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState<State>();

  useEffect(() => {
    const currentUser = localStorage.getItem("user");
    const userData = currentUser ? JSON.parse(currentUser) : null;
    if (userData) history.replace("/app");
      const oneAuthElement = document.querySelector(
        "hfn-auth",
      ) as HTMLElement & { triggerAuth?: () => void };

    if (oneAuthElement?.triggerAuth) {
      oneAuthElement.triggerAuth();
    }
  }, []);

  interface LoginResponse {
    data?: {
      access_token?: string;
    };
  }
  type userLoginDataType = {
    abhyasi_status: string;
    srcmToken: string;
    tokenData: { accessToken: string };
  };

  const handleAuth = (status: boolean) => {
    const element = document.querySelector("hfn-auth") as HTMLElement & {
      // eslint-disable-next-line no-unused-vars
      handleProfileAuthentication?: (status: boolean) => void;
    };
    if (element?.handleProfileAuthentication) {
      element.handleProfileAuthentication(status);
    }
  };

  const logout = async () => {
    const params = getKeycloakAuthConfig();
    const res = await userLogout(params);
    if (!res?.error) {
      localStorage.clear();
      setTimeout(() => {
        window.location.replace("/#/login");
      }, 2000);
    }
    return;
  };

  const userLogin = async (jwtToken: any) => {
    try {
      const reqBody: ConnectUserRequest = new ConnectUserRequest();
      reqBody.setIsadminlogin(true);

      grpc.unary(HeartIntuneProfileService.UserLogin, {
        host: HEARTINTUNE_PROFILE_SERVICE_HOST,
        request: reqBody,
        metadata: {
          Authorization: `Bearer ${jwtToken}`,
        },

        onEnd: async (res: UnaryOutput<ConnectUserResponse>) => {
          const { status, statusMessage, message } = res;
          if (status === grpc.Code.OK && message) {
            if (message) {
              const userRole = message.toObject().user?.role;
              localStorage.setItem("user", JSON.stringify(message.toObject().user));
              dispatch(userRoleUpdate(userRole));
              if (userRole === (Role.USER || Role.CUSTOM_ROLE || Role.UNKNOWN_ROLE)) {
                //history.replace("/login");
                setState({
                  loading: false,
                  errorMessage: "You are not authorized to sign in to admin portal",
                  showError: true,
                });
                await logout();
              } else {
                if (!history.location.pathname.match("/app")) window.location.replace("/#/app");
              }
            }
          } else if (status === grpc.Code.Unauthenticated) {
            forceLogout();
          } else {
            setState({
              loading: false,
              errorMessage:
                "User not found in the database. Please make sure you have signed up using the Heartfulness app before attempting to log in here.",
              showError: true,
            });
            await logout();
          }
        },
      });
    } catch (err: any) {
      setState({
        loading: false,
        errorMessage: `${err?.message || err.toString()}. Try sign in using google`,
        showError: true,
      });
    }
  };


    useEffect(() => {
      const loadAuth = async () => {
        try {
          await import("hfn-auth-legacy/dist/main").then(() => {
            const element = document.querySelector(
              "hfn-auth",
            ) as HTMLElement & {
              loginCallback?: (_res: LoginResponse) => Promise<boolean>;
            };
            if (element) {
              element.loginCallback = async (res: LoginResponse) => {
                try {
                  const accessInfo = res?.data;
                  if (!accessInfo?.access_token) {
                    handleAuth(false);
                    return false;
                  }
                  localStorage.setItem("loginDateTime", new Date().toString());
                  localStorage.setItem(
                    "authInfo",
                    JSON.stringify({ srcmToken: accessInfo?.access_token }),
                  );

                  if (accessInfo?.access_token) {
                    await userLogin(accessInfo?.access_token);
                    return true;
                  }
                } catch (err) {
                  handleAuth(false);
                  return false;
                }
                handleAuth(true);
                return true;
              };
            }
          })
          .catch(err => {
            // console.log(err);
          });
      } catch (error) {
        handleAuth(false);
      }
    };

    loadAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // Full viewport height
        }}
      >
        <CircularProgress />
      </Box>
      <Snackbar
        key="login-snack"
        anchorOrigin={{ horizontal: "center", vertical: "top" }}
        autoHideDuration={6000}
        open={state?.showError}
        onClose={() => {
          setState({
            showError: false,
          });
        }}
      >
        <Alert severity="error">{state?.errorMessage}</Alert>
      </Snackbar>
    </Container>
  );
}
